module.exports = __webpack_public_path__ + "img/beyoutiful.007c21f1.jpg";